export default "__VITE_ASSET__j8_lBJ41__"